const variantClasses = {
  trending: "bg-red-600 text-white",
  soldout: "bg-orange-600 text-white animate-pulse",
  live: "bg-green-600 text-white",
  new: "bg-blue-600 text-white",
  default: "bg-[#1F2937] text-white/70",
};

export function MarketplaceEventBadge({ children, variant = "default", className = "" }) {
  return (
    <span
      className={`inline-flex items-center px-2.5 py-1 rounded-lg text-[10px] font-black uppercase tracking-wider ${variantClasses[variant] || variantClasses.default} ${className}`}
    >
      {children}
    </span>
  );
}
